import { CON_ORTC_EXCHANGE, CON_ORTC_RETURN } from "../sys/Constants";

const storageKey = (orderCode) => `cenote_rt_${orderCode}`;

const isValidCeNoteType = (code) => {
  const n = Number(code);
  return n === CON_ORTC_RETURN || n === CON_ORTC_EXCHANGE;
};

/** Read return type from ORDER_API_07 payload dtrefunddet. */
export function getCeNoteTypeFromPayload(orderPayload) {
  const code = orderPayload?.dtrefunddet?.[0]?.RETURNTYPECODE;
  return isValidCeNoteType(code) ? Number(code) : null;
}

/** Persist credit/exchange note return type for bill reprints (ORDER_API_06 has no type field). */
export function persistCeNoteReturnType(orderCode, returnTypeCode, amount) {
  if (!orderCode || !amount || !isValidCeNoteType(returnTypeCode)) return;
  try {
    sessionStorage.setItem(storageKey(orderCode), String(returnTypeCode));
  } catch {
    // ignore quota / private-mode errors
  }
}

/** Resolve return type from URL query param or sessionStorage fallback. */
export function resolveCeNoteReturnType(orderCode, queryParam) {
  if (isValidCeNoteType(queryParam)) return Number(queryParam);
  if (!orderCode) return null;
  try {
    const stored = sessionStorage.getItem(storageKey(orderCode));
    if (isValidCeNoteType(stored)) return Number(stored);
  } catch {
    // ignore
  }
  return null;
}
